<div class="flex flex-col gap-6">
    <!-- header -->
    <div>
        <h3 class="font-heading text-[26px] font-bold leading-none tracking-tight">Compensation</h3>
        <p class="mt-2 max-w-[60ch] text-[13px] leading-relaxed text-muted-foreground">
            Below is a breakdown of what you can expect to pay each creator.
        </p>
    </div>

    <!-- headline summary bar -->
    <div
        class="flex flex-col gap-4 rounded-xl bg-brand-deep-purple px-6 py-5 text-white sm:flex-row sm:items-stretch sm:gap-0">
        <div class="flex-1">
            <div class="text-[11px] font-bold uppercase tracking-[0.06em] text-white/60">Price per creator</div>
            <div class="mt-1 font-heading text-3xl font-extrabold leading-none">{{ pricePerCreatorLabel() }}</div>
            <div class="mt-1.5 text-[13px] text-white/60">{{ videos() }} video{{ videos() === 1 ? '' : 's' }} each</div>
        </div>
        <div class="hidden w-px self-stretch bg-white/15 sm:block"></div>
        <div class="flex-1 sm:pl-6">
            <div class="text-[11px] font-bold uppercase tracking-[0.06em] text-white/60">Estimated total</div>
            <div class="mt-1 font-heading text-3xl font-extrabold leading-none">{{ estimatedTotalLabel() }}</div>
            <div class="mt-1.5 text-[13px] text-white/60">× {{ creators() }} creator{{ creators() === 1 ? '' : 's' }}
            </div>
        </div>
    </div>

    <!-- cash payment details (posted briefs only — UGC is a flat price above) -->
    @if (!isUgcOnly()) {
    <div class="rounded-xl border border-brand-studio/40 bg-brand-studio/[0.06] p-6">
        <h4 class="font-heading text-lg font-bold">Cash Payment Details</h4>
        <p class="text-xs text-muted-foreground">Creators will be paid cash for their work.</p>

        <div class="mt-4 grid grid-cols-1 gap-5 sm:grid-cols-2">
            <!-- base price per video -->
            <div>
                <label class="block text-sm font-medium">
                    Base price per video
                    <span class="block text-xs font-normal text-muted-foreground">The base price of the brief before any
                        modifiers or audiences are applied.</span>
                </label>
                <div class="mt-1.5 flex items-center rounded-md border border-border bg-card/50 px-3 py-2 text-sm">
                    <span class="select-none text-muted-foreground">{{ currencySymbol() }}</span>
                    <span class="ml-1 text-foreground">{{ basePrice() | number: '1.2-2' }}</span>
                </div>
            </div>

            <!-- number of videos -->
            <div>
                <label class="block text-sm font-medium">
                    Number of videos
                    <span class="block text-xs font-normal text-muted-foreground">The price is multiplied by the number
                        of unique pieces.</span>
                </label>
                <div
                    class="mt-1.5 flex items-center rounded-md border border-border bg-card/50 px-3 py-2 text-sm text-foreground">
                    {{ videos() }}
                </div>
            </div>
        </div>

        <!-- expect to pay -->
        @if (tierCards().length) {
        <div class="mt-5">
            <label class="block text-sm font-medium">
                Expect to pay
                <span class="block text-xs font-normal text-muted-foreground">For creators with audiences in the
                    following groups, you can expect to pay per creator…</span>
            </label>
            <ul role="list" class="mt-3 grid grid-cols-1 gap-2.5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                @for (tier of tierCards(); track tier.title) {
                <li class="flex items-center justify-between rounded-lg border border-border bg-card px-4 py-3.5">
                    <div class="min-w-0">
                        <div class="font-heading text-base font-bold">{{ tier.title }}</div>
                        <div class="text-xs text-muted-foreground">{{ tier.range }}</div>
                    </div>
                    <!-- <div class="font-heading text-xl font-extrabold">{{ tier.perCreatorLabel }}</div> -->
                    <div class="font-heading text-base font-extrabold">{{ currencySymbol() }}{{ getExpectedPayment(tier.bonusValue) | number:'1.2-2' }}</div>
                    
                </li>
                }
            </ul>
        </div>
        } @else {
        <div class="mt-5">
            <label class="block text-sm font-medium">
                Total cost per creator
                <span class="block text-xs font-normal text-muted-foreground">Each creator will be paid this
                    amount.</span>
            </label>
            <div class="mt-1.5 flex items-center rounded-md border border-border bg-card/50 px-3 py-2 text-sm">
                <p class="m-0 select-none text-muted-foreground">{{ currencySymbol() }}</p>
                <p class="m-0 ml-1 text-foreground">{{ getExpectedPayment(0) | number: '1.2-2' }}</p>
            </div>
        </div>
        }
    </div>
    }
</div>